import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    NumberInput,
    ImageInput,
    ImageField,
    BooleanInput,
    required,
    maxLength,
} from 'react-admin';

const SellerForm = () => (
    <SimpleForm redirect="list">
        <TextInput source="name" label='Nombre' validate={[required(), maxLength(200)]} />
        <TextInput source="webSite" label='Sitio Web' validate={[required(), maxLength(200)]} />
        <NumberInput source="position" label='Orden' validate={[required()]} />
        <BooleanInput source="active" label="resources.sellers.fields.active" />
        <ImageInput 
            source="image" 
            label="Imagen *" 
            accept="image/*"
            validate={[required()]}
            placeholder={<p>Click aquí o arrastre y suelte la imagen</p>}
            format={(value) => {
                if (typeof value === 'string' && value !== '') {
                    return { src: value };
                }
                return value;
            }}
        >
            <ImageField source="src" title="title" />
        </ImageInput>
    </SimpleForm>
);

export const EditSeller = () => (
    <Edit>
        <SellerForm />
    </Edit>
);